import { Component, OnInit, Injectable, Input } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AssetsService } from '../../../shared/services/assets.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/forkJoin';
import { Asset, AssetLanguage, Provider } from '../../models';
import { FormGroup } from '@angular/forms';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { UrlService } from '../../../shared/services/url.service';
import { UrlHelperService } from '../../../shared/services/urlHelperService';


@Component({
  selector: 'app-assets',
  templateUrl: '../templates/assets.component.html'
})

@Injectable()
export class AssetsComponent implements OnInit {

  IsEdition: boolean;
  showDeactivateButton: boolean;
  Providers: any[];
  emptyProviders: any;
  @Input() assetModel: Asset;
  title = 'Assets';
  AssetId: string;
  asset$: Observable<any>;
  AssetsWithLastCandle = [];
  DashboardUrl: string;

  constructor(private route: ActivatedRoute,
    private assetsService: AssetsService,
    private alertService: AlertService,
    private urlService: UrlService,
    private urlHelperService: UrlHelperService) {

    this.assetModel = {
      AssetLanguage: {} as AssetLanguage,
      Providers: [] as Provider[]
    } as Asset;

    this.DashboardUrl = this.urlService.GetDashboardRoute();
  };

  ngOnInit() {
    this.AssetId = this.route.snapshot.params.assetId;

    Observable.forkJoin([
      this.assetsService.GetProviders(),
      this.assetsService.GetAssetsWithCalculation()
    ]).subscribe(value => {
      this.Providers = value[0],
        this.AssetsWithLastCandle = value[1].Values,
        this.initModel()
    }, err => this.alertService.add('danger', 'Error getting initial assets values: ' + err));
  };

  initModel() {
    if (this.AssetId) {
      this.asset$ = this.route.paramMap.switchMap((params: ParamMap) => this.assetsService.GetById(params.get('assetId')));
      this.asset$.subscribe(data => this.fillModel(data), err => this.alertService.add('danger', 'Get assetById error: ' + err));
    }
  };


  fillModel(asset: any) {
    if (this.AssetId) {
      this.assetModel = asset;
      this.loadProviders();
      this.showDeactivateButton = this.showDeactivateOption();
      this.IsEdition = true;
    }
  };

  public Save(form: FormGroup) {
    this.alertService.removeAll();
    this.mapProvidersToModel();
    if (!form.valid) {
      this.alertService.add('danger', 'There are some errors in the form.');
      return;
    }

    if (this.AssetId) {
      this.Edit();
    } else {
      this.Create();
    }
  };

  Create = function () {
    this.assetsService.Create(this.assetModel)
      .subscribe(asset => this.createSuccess(), err => this.alertService.add('danger', 'Create Asset error: ' + err));
  };

  Edit = function () {
    this.assetsService.Edit(this.assetModel)
      .subscribe(() => this.editSuccess(), err => this.alertService.add('danger', 'Edit Asset error: ' + err));
  };

  public Deactivate() {
    this.alertService.removeAll();
    const assetId = this.assetModel.Id;
    this.assetsService.Deactivate(assetId)
      .subscribe(() => this.deactivateSuccess(), err => this.alertService.add('danger', 'Delete Asset error: ' + err));
  };

  loadProviders() {
    if (this.assetModel.Providers) {
      this.Providers.forEach(provider => {
        const providerInAsset = this.assetModel.Providers.filter(function (assetProvider, index) {
          return assetProvider.Id === provider.Id;
        });

        if (providerInAsset.length > 0) {
          provider.AssetCode = providerInAsset[0].AssetCode;
          provider.AssetId = providerInAsset[0].AssetId;
        }
      });
    }
  };

  mapProvidersToModel() {
    const filledProviders = this.Providers.filter(function (filledProvider: any, index) {
      return filledProvider.AssetCode;
    });

    this.assetModel.Providers = filledProviders;
  };

  showDeactivateOption() {
    const self = this;
    const assetInCalculations = this.AssetsWithLastCandle.filter(function (assetWithCalculation: any, index) {
      return assetWithCalculation.Id === self.AssetId;
    });

    return assetInCalculations.length === 0;
  };

  public FillUrl = function () {
    if (this.assetModel.AssetLanguage.Name && !this.IsEdition) {
      const url = this.urlHelperService.generateUrl(this.assetModel.AssetLanguage.Name);
      this.assetModel.AssetLanguage.Url = url;
    }
  };

  createSuccess() {
    this.alertService.add('success', 'Asset successfully created');
  };

  editSuccess() {
    this.alertService.add('success', 'Asset has been edited.');
  };

  deactivateSuccess() {
    this.alertService.add('success', 'Asset has been deactivated.');
  };

}



// WEBPACK FOOTER //
// ./src/app/assets/components/scripts/assets.component.ts